<template>
  <div class="burger-wrapper" @click="toggle">
    <div
      class="burger"
      :class="{
        '-active': active,
        '-not-active': !active,
        '-init': !firstClick,
      }"
    >
      <span class="burger-line -top" />
      <span class="burger-line -middle" />
      <span class="burger-line -bottom" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'BurgerController',
  props: {
    active: Boolean
  },
  data: function () {
    return {
      firstClick: false
    };
  },
  methods: {
    toggle () {
      if (!this.firstClick) {
        this.firstClick = true;
      }
      this.$emit('toggle');
    }
  }
};
</script>

<style lang="scss">
@import "@/scss/defaults.scss";
$anim-delay: 0.3s;
$anim-ease: ease-in-out;

$burger-size: 18px;

.burger-wrapper {
  margin-top: 0;
  padding-left: 9px;
  text-align: right;

  @include media-breakpoint-up(md) {
    padding-right: 12px;
  }

  @include media-breakpoint-up(lg) {
    display: none;
  }
}

.burger {
  position: relative;
  width: $burger-size;
  height: $burger-size;

  &-line {
    position: absolute;
    left: 0;
    width: 100%;
    height: 2px;
    cursor: pointer;
    background-color: #000;
    transition: background-color 0.5s;

    &.-top {
      top: $burger-size / 6;
    }

    &.-middle {
      top: $burger-size / 2;
    }

    &.-bottom {
      top: ($burger-size / 6) * 5;
    }
  }
}

.burger.-active {
  .burger-line {
    &.-top {
      animation: $anim-delay $anim-ease forwards TOP_ANIM;
    }
    &.-middle {
      animation: $anim-delay $anim-ease forwards MIDDLE_ANIM;
    }
    &.-bottom {
      animation: $anim-delay $anim-ease forwards BOTTOM_ANIM;
    }
  }
}

.burger.-not-active:not(.-init) {
  .burger-line {
    &.-top {
      animation: $anim-delay $anim-ease forwards TOP_ANIM_BACK;
    }
    &.-middle {
      animation: $anim-delay $anim-ease forwards MIDDLE_ANIM_BACK;
    }
    &.-bottom {
      animation: $anim-delay $anim-ease forwards BOTTOM_ANIM_BACK;
    }
  }
}

@keyframes TOP_ANIM {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY($burger-size / 3);
  }
  100% {
    transform: translateY($burger-size / 3) rotate(45deg);
  }
}

@keyframes BOTTOM_ANIM {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-$burger-size / 3);
  }
  100% {
    transform: translateY(-$burger-size / 3) rotate(-45deg);
  }
}

@keyframes MIDDLE_ANIM {
  0% {
    transform: scaleX(1);
  }
  50% {
    transform: scaleX(1);
  }
  100% {
    transform: scaleX(0);
  }
}
@keyframes TOP_ANIM_BACK {
  0% {
    transform: translateY($burger-size / 3) rotate(45deg);
  }
  50% {
    transform: translateY($burger-size / 3);
  }
  100% {
    transform: translateY(0);
  }
}

@keyframes BOTTOM_ANIM_BACK {
  0% {
    transform: translateY(-$burger-size / 3) rotate(-45deg);
  }
  50% {
    transform: translateY(-$burger-size / 3);
  }
  100% {
    transform: translateY(0);
  }
}

@keyframes MIDDLE_ANIM_BACK {
  0% {
    transform: scaleX(0);
  }
  50% {
    transform: scaleX(1);
  }
  100% {
    transform: scaleX(1);
  }
}
</style>
